import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/hvac';
const INCLUDED = ['6 Professional Diagnostic Modules', '4 Professional Bonuses', 'Visual Diagnostic Maps', 'Troubleshooting Flowcharts', 'Symptom-Based Pathways', 'Component References', 'Testing & Measurement Resources', 'Field Organization Tools'];
export function Offer() {
  return <section id="offer" className="bg-navy px-4 py-5 sm:py-7" data-id="element-101" data-mp="tz3hj0zfpf7v">
      <div className="mx-auto max-w-3xl" data-id="element-102" data-mp="p0tmqrhmggms">
        <p className="text-center text-[10px] font-extrabold uppercase tracking-[0.2em] text-diag sm:text-xs" data-id="element-103" data-mp="p1v052m41f7o">
          Special Launch Offer
        </p>
        <h2 className="mt-1 text-center text-xl leading-tight text-white sm:text-3xl" data-id="element-104" data-mp="yxogkx2y9suq">
          🔧 HVAC DIAGNOSTIC READY™
        </h2>
        <p className="mt-1 text-center text-xs font-extrabold uppercase tracking-wide text-white/85 sm:text-sm" data-id="element-105" data-mp="2fad3riqdh0eq">
          The complete visual troubleshooting system for HVAC technicians
        </p>

        <div className="mt-3 rounded-xl border-2 border-diag bg-white p-3 sm:p-4" data-id="element-106" data-mp="pjz47x579lzu">
          <div className="grid gap-3 sm:grid-cols-2 sm:items-center" data-id="element-107" data-mp="uhqs8g2q4nyr">
            <a href={CHECKOUT_URL} className="block" data-id="element-108" data-mp="zi54kabcyk2l">
              <img src={HERO_IMAGE} alt="Everything included in HVAC DIAGNOSTIC READY™" loading="lazy" className="mx-auto w-full max-w-[260px]" data-id="element-109" data-mp="zgk82f5hgr23" />
            </a>
            <div data-id="element-110" data-mp="bs0zrzmfoea0">
              <p className="font-display text-base uppercase text-navy sm:text-lg" data-id="element-111" data-mp="btlupqcntz8e">
                Complete 6-in-1 Visual Diagnostic System
              </p>
              <ul className="mt-1.5 grid gap-1" data-id="element-112" data-mp="kkvvo2q0gxn4">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-charcoal" data-id="element-113" data-mp="3k8lzsqx37x0z">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-service" aria-hidden="true" strokeWidth={3} data-id="element-114" data-mp="3o8edfi1c8td7" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-3 border-t border-navy/10 pt-3 text-center" data-id="element-115" data-mp="157d5jqnyyxr9">
            <p className="font-display text-lg uppercase text-alert sm:text-xl" data-id="element-116" data-mp="106z44rgvim27">
              🔥 Get HVAC DIAGNOSTIC READY™ Today
            </p>
            <p className="mt-1 font-display text-5xl leading-none text-navy sm:text-6xl" data-id="element-117" data-mp="7i1oyx7yl5do">
              $27
            </p>
            <CTAButton className="mx-auto mt-2 max-w-md" sub="Immediate Digital Access" data-id="element-118" data-mp="lim7ds9yoz6n">
              🔧 YES! I WANT THE COMPLETE SYSTEM
            </CTAButton>
            <p className="mt-1.5 text-xs font-bold text-service" data-id="element-119" data-mp="1wvor2w7cy4v1">
              🛡️ 7-Day Money-Back Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}